import { render, staticRenderFns } from "./ShareHeader.vue?vue&type=template&id=1a3997ee&scoped=true"
import script from "./ShareHeader.vue?vue&type=script&lang=js"
export * from "./ShareHeader.vue?vue&type=script&lang=js"
import style0 from "./ShareHeader.vue?vue&type=style&index=0&id=1a3997ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3997ee",
  null
  
)

export default component.exports